<div *ngIf="collectionTitle && featuredCollections">
    <h1 class="mt-2">Featured {{ collectionTitle }} Collections</h1>
    <div class="selenium-app-collections collection-cards-container">
        <div class="d-flex ms-0 my-6 card-items">
            <app-collection-browse-card
                class="pe-md-4"
                [ngClass]="{
                    'custom-padding-start': index !== 0,
                    'custom-padding-end': index === 0,
                }"
                *ngFor="let collection of featuredCollections; let index = index"
                [learningObject]="collection"
                [gtmPrefix]="gtmPrefix"
            >
            </app-collection-browse-card>
        </div>
    </div>
</div>
